export var Literal = 'Literal';
export var Identifier = 'Identifier';



// WEBPACK FOOTER //
// ./~/vega-parser/src/parsers/expression/ast.js